import { span } from "framer-motion/client";
import { personalInfo } from "../data/portfolio";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.06] px-6 md:px-16 lg:px-24 py-8 z-10">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="font-display font-black text-lg grad-text">UK.</span>
          <span className="w-px h-4 bg-white/10" />
          <p className="font-mono text-xs text-white/25 tracking-wide">
            {personalInfo.name} · Software Developer & Blockchain Developer
          </p>
        </div>
        <p className="font-mono text-xs text-white/20 tracking-wide">
          © {new Date().getFullYear()} ·{" "}
          {
            <span className="grad-text text-yellow-200">
              Ujjwal Kumar - Portfolio
            </span>
          }
        </p>
      </div>
    </footer>
  );
}
